/**
 * Modal pour afficher les informations du parent (compte utilisateur)
 */
const ParentInfoModal = ({ isOpen, onClose, inscription }) => {
  if (!isOpen || !inscription) return null;

  const parentDetails = inscription.enfant_details?.parent_details;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose}></div>

      {/* Modal content */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left shadow-xl transition-all">
          {/* En-tête */}
          <div className="flex items-start justify-between mb-4">
            <h3 className="text-lg font-semibold leading-6 text-gray-900" id="modal-title">
              Informations du parent
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Informations de l'enfant */}
          <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-xs text-blue-600 font-medium mb-1">Enfant concerné</p>
            <p className="text-sm font-semibold text-gray-900">
              {inscription.enfant_details?.prenom} {inscription.enfant_details?.nom}
            </p>
          </div>

          {/* Informations du parent */}
          <div className="space-y-4">
            {/* Nom et prénom */}
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">
                Nom et prénom
              </label>
              <div className="flex items-center text-gray-900">
                <svg className="h-5 w-5 mr-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span className="font-medium">
                  {parentDetails?.prenom} {parentDetails?.nom || <span className="text-gray-400">Non renseigné</span>}
                </span>
              </div>
            </div>

            {/* Email */}
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">
                Email
              </label>
              <div className="flex items-center text-gray-900">
                <svg className="h-5 w-5 mr-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                {parentDetails?.email ? (
                  <a
                    href={`mailto:${parentDetails.email}`}
                    className="font-medium text-primary-600 hover:text-primary-700 hover:underline"
                  >
                    {parentDetails.email}
                  </a>
                ) : (
                  <span className="text-gray-400">Non renseigné</span>
                )}
              </div>
            </div>

            {/* Téléphone */}
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">
                Téléphone
              </label>
              <div className="flex items-center text-gray-900">
                <svg className="h-5 w-5 mr-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                {parentDetails?.telephone ? (
                  <a
                    href={`tel:${parentDetails.telephone}`}
                    className="font-medium text-primary-600 hover:text-primary-700 hover:underline"
                  >
                    {parentDetails.telephone}
                  </a>
                ) : (
                  <span className="text-gray-400">Non renseigné</span>
                )}
              </div>
            </div>

            {/* Adresse */}
            {parentDetails?.adresse && (
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">
                  Adresse
                </label>
                <div className="flex items-start text-gray-900">
                  <svg className="h-5 w-5 mr-2 mt-0.5 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span className="font-medium">{parentDetails.adresse}</span>
                </div>
              </div>
            )}
          </div>

          {/* Bouton de fermeture */}
          <div className="mt-6">
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-lg border border-transparent bg-primary-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
              onClick={onClose}
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParentInfoModal;
